const IMAGES_REFRESH_DEBOUNCE_MS = 100

const isBviActive = () =>
  document.body.classList.contains("bvi-active")

const refreshBviImages = () => {
  if (!isBviActive() || !window.bvi)
    return

  window.bvi._images()
}

const hasAddedElements = (mutations: MutationRecord[]): boolean =>
  mutations.some(mutation =>
    Array.from(mutation.addedNodes).some(node => node.nodeType === Node.ELEMENT_NODE),
  )

const plugin: NuxtPlugin = () => {
  let debounceTimer: ReturnType<typeof setTimeout> | null = null

  const observer = new MutationObserver((mutations) => {
    if (!hasAddedElements(mutations))
      return

    if (debounceTimer !== null)
      clearTimeout(debounceTimer)

    debounceTimer = setTimeout(refreshBviImages, IMAGES_REFRESH_DEBOUNCE_MS)
  })

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  })
}

export default plugin
